import React from 'react';
import PropTypes from 'prop-types';
import HorizontalDrawerLink from './HorizontalDrawerLink';

class DrawerLinks extends React.PureComponent {
  static propTypes = {
    route: PropTypes.shape({
      matchPath: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
      ]),
      id: PropTypes.string,
      getChildRoutes: PropTypes.func,
    }).isRequired,
    authService: PropTypes.shape({
      acceptRoute: PropTypes.func,
    }).isRequired,
    routeService: PropTypes.shape({
      getChildRoutes: PropTypes.func,
    }).isRequired,
  };

  render() {
    const { authService, ...drawersProps } = this.props;
    const { route, routeService } = this.props;
    const childRoutes = routeService.getChildRoutes(route, this.props, { routeInDrawer: true, useSelfIfEmpty: false });
    return (
      <React.Fragment>
        {childRoutes.map((child) => {
          return (
            <HorizontalDrawerLink
              {...drawersProps}
              label={child.label}
              key={child.id}
              Icon={child.icon}
              to={child.url(drawersProps)}
              disabled={child.disabled}
              authService={authService}
              route={child}
            />
          );
        })}
      </React.Fragment>
    );
  }
}

export default DrawerLinks;
